import React from 'react';
import { IconProps } from './types';

const MuteCircledIcon: React.FC<IconProps> = props => {
  const { height = '24', width = '24' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill="#29A1A3" />
      <mask id="mask0_14977_208009" maskUnits="userSpaceOnUse" x="6" y="6" width="16" height="16">
        <rect x="6" y="6" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_14977_208009)">
        <path
          d="M14.0002 15.3332C13.4446 15.3332 12.9724 15.1387 12.5835 14.7499C12.1946 14.361 12.0002 13.8887 12.0002 13.3332V9.33319C12.0002 8.77764 12.1946 8.30541 12.5835 7.91652C12.9724 7.52764 13.4446 7.33319 14.0002 7.33319C14.5558 7.33319 15.028 7.52764 15.4169 7.91652C15.8058 8.30541 16.0002 8.77764 16.0002 9.33319V13.3332C16.0002 13.8887 15.8058 14.361 15.4169 14.7499C15.028 15.1387 14.5558 15.3332 14.0002 15.3332ZM14.0002 19.9999C13.8113 19.9999 13.653 19.936 13.5252 19.8082C13.3974 19.6804 13.3335 19.5221 13.3335 19.3332V17.9332C12.3002 17.7999 11.4224 17.3721 10.7002 16.6499C9.97798 15.9276 9.53909 15.061 9.38354 14.0499C9.3502 13.861 9.4002 13.6943 9.53354 13.5499C9.66687 13.4054 9.84465 13.3332 10.0669 13.3332C10.2224 13.3332 10.3613 13.3915 10.4835 13.5082C10.6058 13.6249 10.6835 13.7665 10.7169 13.9332C10.8613 14.711 11.2391 15.361 11.8502 15.8832C12.4613 16.4054 13.178 16.6665 14.0002 16.6665C14.8224 16.6665 15.5391 16.4054 16.1502 15.8832C16.7613 15.361 17.1391 14.711 17.2835 13.9332C17.3169 13.7665 17.3974 13.6249 17.5252 13.5082C17.653 13.3915 17.7946 13.3332 17.9502 13.3332C18.1613 13.3332 18.3335 13.4054 18.4669 13.5499C18.6002 13.6943 18.6502 13.861 18.6169 14.0499C18.4613 15.061 18.0224 15.9276 17.3002 16.6499C16.578 17.3721 15.7002 17.7999 14.6669 17.9332V19.3332C14.6669 19.5221 14.603 19.6804 14.4752 19.8082C14.3474 19.936 14.1891 19.9999 14.0002 19.9999Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default MuteCircledIcon;
